import { jsx as _jsx, jsxs as _jsxs } from 'react/jsx-runtime.js';
import { Flex, Paragraph } from '@stepstone-genesis/components';
import { CheckIcon } from '@stepstone-genesis/icons';
export const BenefitItem = ({ text }) => {
    return (_jsxs(Flex, { gap: ['spaceS', 'spaceS2'], flxItems: 'center', children: [_jsx(Flex, { className: "benefit-item", flxItems: 'center', flxJustify: 'center', flxShrink: 0, sx: {
                    maxWidth: ['iconSizeXs', 'iconSizeM', 'iconSizeXxl'],
                    maxHeight: ['iconSizeXs', 'iconSizeM', 'iconSizeXxl'],
                    borderRadius: '50%',
                    backgroundColor: 'rgba(255, 255, 255, 0.2)',
                }, children: _jsx(CheckIcon, { color: 'colorBlack', size: ['medium', 'large', 'xxl'] }) }), _jsx(Paragraph, { size: ['xs', 'medium', 'xl'], lineHeight: [
                    'lineHeightXxs',
                    'lineHeightXs',
                    'lineHeightL',
                    'lineHeightXl',
                ], children: text })] }));
};
//# sourceMappingURL=BenefitItem.js.map